module.exports = __webpack_public_path__ + "img/2.5ce3b6d0.png";